import { GrayLogService } from 'src/app/cadastro/admin/services/graylog/graylog.service';
import { Injectable } from "@angular/core"
import { environment } from "../../../environments/environment"
import { UserService, AccountService } from "@app/cadastro/admin"
import { firstValueFrom, tap } from "rxjs"
import { IUser } from "@app/shared/interfaces/user"

interface IChatvoltContact {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
}

interface IChatvoltConfig {
  agentId: string;
  contact?: IChatvoltContact;
}

@Injectable({
  providedIn: "root",
})
export class ChatvoltService {
  constructor(
    private userService: UserService,
    private accountService: AccountService,
    public GrayLogService: GrayLogService
  ) {}

  async loadChatvolt() {
    const user = await firstValueFrom(this.userService.getUserInfo())
    let fullUserDetails: IUser | null = null
    try {
      fullUserDetails = await firstValueFrom(this.accountService.getUserInformations(user.id)) as IUser
    } catch (error) {
      this.GrayLogService.logError(error)
    }
    const chatvoltContact = this.buildContactObject(fullUserDetails)

    this.loadChatvoltScript(chatvoltContact)
  }

  buildContactObject(user: IUser | null): IChatvoltContact | null {
    if (!user) return null

    const nameParts = user.name ? user.name.split(' ') : []
    const firstName = nameParts[0] || ''
    const lastName = nameParts.slice(1).join(' ') || ''

    const contact: IChatvoltContact = {}

    if (firstName) contact.firstName = firstName
    if (lastName) contact.lastName = lastName
    if (user.email) contact.email = user.email

    return Object.keys(contact).length > 0 ? contact : null
  }

  loadChatvoltScript(contact: IChatvoltContact | null) {
    const script = document.createElement('script')
    script.type = 'module'
    const config: IChatvoltConfig = {
      agentId: environment.chatVoltUris.agentId,
    }

    if (contact) {
      config.contact = contact
    }

    script.innerHTML = `
      import Chatbox from 'https://cdn.jsdelivr.net/npm/@chatvolt/embeds@latest/dist/chatbox/index.js';
      Chatbox.initBubble(${JSON.stringify(config)});
    `
    document.body.appendChild(script)
  }
}
